// src/components/Sidebar.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();

 const navItems = [
  { path: '/dashboard', icon: 'fa-chart-pie', label: 'Dashboard' },
  { path: '/sliders', icon: 'fa-images', label: 'Sliders' },
  { path: '/news', icon: 'fa-newspaper', label: 'News' },
  { path: '/notifications', icon: 'fa-bell', label: 'Notifications' },
  { path: '/gallery', icon: 'fa-images', label: 'Gallery' },
  { path: '/faculty', icon: 'fa-user-tie', label: 'Faculty' },
  { path: '/events', icon: 'fa-calendar-days', label: 'Events' },
  { path: '/courses', icon: 'fa-graduation-cap', label: 'Courses' },
  { path: '/testimonials', icon: 'fa-comment-dots', label: 'Reviews' },
  { path: '/departments', icon: 'fa-building', label: 'Departments' },
  { path: '/contact', icon: 'fa-address-card', label: 'Contact' },
  { path: '/settings', icon: 'fa-sliders', label: 'Settings' },
];

  return (
    <>
      <div className={`sidebar-overlay ${isOpen ? 'active' : ''}`} onClick={onClose} />
      <aside className={`sidebar ${isOpen ? 'active' : ''}`}>
        <div className="sidebar-header">
          <h2><i className="fas fa-graduation-cap"></i> College Admin</h2>
          <button className="sidebar-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={location.pathname === item.path ? 'active' : ''}
              onClick={onClose}
            >
              <i className={`fas ${item.icon}`}></i>
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;